'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _reduxForm = require('redux-form');

var _reactRouterRedux = require('react-router-redux');

var _lib = require('../../helpers/lib');

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WAIT_INTERVAL = 1000;
var ENTER_KEY = 13;
var Search = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    provinces: state.address.provinces,
    province: state.address.province,
    categories: state.setup.categories,
    categoriesFilter: state.setup.categoriesFilter,
    query: state.filter.query,
    sort: state.filter.sort,
    locationUser: state.user.coords,
    districts: state.address.districts,
    district_parent: state.address.district_parent,
    districts_loading: state.address.districts_loading,
    addressFilter: state.address.addressFilter,
    subCatFilter: state.setup.subCatFilter,
    loading: state.filter.loading
  };
}, (0, _extends3.default)({}, addressActions, filterActions, setupActions, {
  initializeWithKey: _reduxForm.initializeWithKey,
  push: _reactRouterRedux.push
})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false,
      addressFilter: _this.props.addressFilter || [],
      categoriesFilter: _this.props.categoriesFilter || {},
      subCatFilter: _this.props.subCatFilter || {},
      query: _this.props.query
    }, _this.handleChangeProvince = function (selectedOption) {
      if (selectedOption && selectedOption.value) {
        if (selectedOption.value !== _this.props.province) {
          _this.props.changeProvince(selectedOption.value);
        }
      } else {
        _this.props.changeProvince('79');
      }
    }, _this.handleChangeMainCat = function (event) {
      var code = String(event.target.name);
      var categoriesFilter = (0, _lodash.clone)(_this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      if (categoriesFilter[code] === 'none') {
        categoriesFilter[code] = 'all';
        for (var index = 0; index < _this.props.categories.length; index++) {
          if (_this.props.categories[index].code === code) {
            var childrens = _this.props.categories[index].childrens;
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              subCatFilter[code] = (0, _lodash.union)(subCatFilter[code], [String(childrens[jndex].code)]);
            }
          }
        }
      } else {
        categoriesFilter[code] = 'none';
        subCatFilter[code] = [];
      }
      _this.props.handleMainCat(categoriesFilter, subCatFilter);
    }, _this.handleChangeSubCat = function (event) {
      var code = String(event.target.name);
      var parentCode = code.slice(0, -1);
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      var subCat = [];
      var categoriesFilter = (0, _lodash.clone)(_this.state.categoriesFilter);
      if (subCatFilter[parentCode].indexOf(code) === -1) {
        subCat = (0, _lodash.union)(subCatFilter[parentCode], [String(code)]);
      } else {
        subCat = (0, _lodash.without)(subCatFilter[parentCode], String(code));
      }
      subCatFilter[parentCode] = subCat;
      var flag = false;
      for (var index = 0; index < _this.props.categories.length; index++) {
        if (_this.props.categories[index].code === parentCode) {
          if (_this.props.categories[index].childrens.length === subCat.length) {
            flag = true;
          }
        }
      }
      if (flag === true) {
        categoriesFilter[parentCode] = 'all';
      } else if (subCat.length > 0) {
        categoriesFilter[parentCode] = 'notAll';
      } else {
        categoriesFilter[parentCode] = 'none';
      }
      _this.props.handleSubCat(subCatFilter, categoriesFilter);
    }, _this.hanldeCheckedAddress = function (event) {
      _this.props.handleDistrictFilter(_this.props.addressFilter, String(event.target.name));
    }, _this.handleShowPopover = function () {
      _this.setState({
        target: function target() {
          return _reactDom2.default.findDOMNode(_this.refs.target);
        },
        show: !_this.state.show
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Search, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.timer = null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (String(this.props.province) !== String(this.props.district_parent) && !this.props.districts_loading) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // flag để xác định khi nào thì search
      var flag = false;
      if (!(0, _lodash.isEqual)(nextProps.addressFilter, this.props.addressFilter)) {
        flag = true;
        this.setState({ addressFilter: nextProps.addressFilter });
      }
      if (nextProps.query !== this.props.query) {
        // trong phan trigger da xu ly phan nay
        if (!this.props.loading) {
          flag = true;
        }
        this.setState({ query: nextProps.query });
      }
      if (!(0, _lodash.isEqual)(nextProps.categoriesFilter, this.props.categoriesFilter)) {
        flag = true;
        this.setState({ categoriesFilter: nextProps.categoriesFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.subCatFilter, this.props.subCatFilter)) {
        flag = true;
        this.setState({ subCatFilter: nextProps.subCatFilter });
      }
      if (nextProps.province !== this.props.province) {
        flag = true;
      }
      if (flag) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getResult.bind(this), WAIT_INTERVAL);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (String(this.props.province) !== String(this.props.district_parent) && !this.props.districts_loading) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter, this.props.sort, this.props.locationUser);
      this.props.changeQuery(this.state.query);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'hanldleSearch',
    value: function hanldleSearch(event) {
      clearTimeout(this.timer);
      this.setState({ query: event.target.value });
      this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode === ENTER_KEY) {
        event.preventDefault();
        clearTimeout(this.timer);
        this.getResult.call(this);
        if (this.props.location && this.props.location.pathname !== '/kham-pha') {
          this.props.push('/kham-pha');
        }
      }
    }
  }, {
    key: 'triggerChange',
    value: function triggerChange() {
      var query = this.state.query;

      this.props.changeQuery(query);
      var filter = (0, _lib.processQuery)(query, this.props.province, this.state.addressFilter, this.state.categoriesFilter, this.state.subCatFilter, this.props.sort, this.props.locationUser);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      event.preventDefault();
      this.setState({ show: false });
      this.getResult.call(this);
      if (this.props.location && this.props.location.pathname !== '/kham-pha') {
        this.props.push('/kham-pha');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Search.scss');
      var _props = this.props,
          provinces = _props.provinces,
          province = _props.province,
          districts = _props.districts,
          categories = _props.categories,
          position = _props.position;
      var _state = this.state,
          addressFilter = _state.addressFilter,
          categoriesFilter = _state.categoriesFilter,
          subCatFilter = _state.subCatFilter,
          query = _state.query;

      var options = [];
      if (provinces && provinces.length) {
        for (var index = 0; index < provinces.length; index++) {
          if (provinces[index].code === '01' || provinces[index].code === '79') {
            options = (0, _lodash.concat)([{ value: provinces[index].code, label: provinces[index].name }], options);
          } else {
            options.push({
              value: provinces[index].code,
              label: provinces[index].name
            });
          }
        }
      }
      // Left category
      var types = [];
      if (categories && categories.length > 0) {
        for (var _index = 0; _index < categories.length; _index++) {
          var subList = [];
          var code = categories[_index].code;
          if (categories[_index].childrens && categories[_index].childrens.length > 0) {
            var childrens = categories[_index].childrens;
            var subArray = subCatFilter[code];
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              var subCode = childrens[jndex].code;
              subList.push(_react2.default.createElement(
                'li',
                { key: String(_index + '-' + jndex) },
                subArray.indexOf(String(subCode)) !== -1 ? _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: subCode + '_subcat_' + position,
                  name: subCode,
                  onChange: this.handleChangeSubCat,
                  checked: true
                }) : _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: subCode + '_subcat_' + position,
                  name: subCode,
                  onChange: this.handleChangeSubCat
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: subCode + '_subcat_' + position },
                  childrens[jndex].label
                )
              ));
            }
            types.push(_react2.default.createElement(
              'li',
              {
                key: String(_index),
                className: categoriesFilter && categoriesFilter[code] === 'all' ? '' : styles.notAll
              },
              categoriesFilter && categoriesFilter[code] !== 'none' ? _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_cat_' + position,
                name: code,
                className: styles.mainCat,
                onChange: this.handleChangeMainCat,
                checked: true
              }) : _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_cat_' + position,
                name: code,
                className: styles.mainCat,
                onChange: this.handleChangeMainCat
              }),
              _react2.default.createElement(
                'label',
                {
                  className: styles.labelMainCat,
                  htmlFor: code + '_cat_' + position
                },
                categories[_index].label
              ),
              _react2.default.createElement(
                'ul',
                { className: styles.subList },
                subList
              )
            ));
          } else {
            types.push(_react2.default.createElement(
              'li',
              {
                key: String(_index),
                className: categoriesFilter && categoriesFilter[code] === 'all' ? '' : styles.notAll
              },
              categoriesFilter && categoriesFilter[code] !== 'none' ? _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_cat_' + position,
                name: code,
                className: styles.mainCat,
                onChange: this.handleChangeMainCat,
                checked: true
              }) : _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_cat_' + position,
                name: code,
                className: styles.mainCat,
                onChange: this.handleChangeMainCat
              }),
              _react2.default.createElement(
                'label',
                {
                  className: styles.labelMainCat,
                  htmlFor: code + '_cat_' + position
                },
                categories[_index].label
              )
            ));
          }
        }
      }
      // Left Area
      var areas = [];
      if (districts && districts.length > 0 && addressFilter) {
        for (var _index2 = 0; _index2 < districts.length; _index2++) {
          var _code = districts[_index2].code;
          areas.push(_react2.default.createElement(
            'li',
            { key: String(_index2) },
            addressFilter && Array.isArray(addressFilter) && addressFilter.indexOf(String(_code)) !== -1 ? _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: _code + '_location_' + position,
              name: _code,
              onChange: this.hanldeCheckedAddress,
              checked: true
            }) : _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: _code + '_location_' + position,
              name: _code,
              onChange: this.hanldeCheckedAddress
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: _code + '_location_' + position },
              (0, _lib.typeAreaAbbreviation)(districts[_index2].type) + districts[_index2].name
            )
          ));
        }
      }
      return _react2.default.createElement(
        'form',
        {
          className: styles.formSearch,
          model: 'query',
          onSubmit: function onSubmit(val) {
            return _this2.handleSubmit(val);
          }
        },
        _react2.default.createElement(
          'div',
          { className: styles.searchGroup, id: 'search-desktop' },
          _react2.default.createElement(_reactSelect2.default, {
            name: 'province',
            placeholder: 'T\u1EC9nh Th\xE0nh',
            className: styles.searchProvince,
            value: province,
            onChange: this.handleChangeProvince,
            options: options,
            multi: false
          }),
          _react2.default.createElement('input', {
            className: styles.searchValue,
            type: 'text',
            name: 'search',
            placeholder: 'T\xECm ki\u1EBFm theo t\xEAn, \u0111\u1ECBa \u0111i\u1EC3m...',
            value: query,
            onKeyDown: this.handleKeyDown.bind(this),
            onChange: this.hanldleSearch.bind(this)
          }),
          _react2.default.createElement(
            _reactBootstrap.ButtonToolbar,
            { className: styles.buttonToolBar },
            _react2.default.createElement(
              'div',
              {
                ref: 'target',
                className: styles.searchFilter,
                onClick: this.handleShowPopover
              },
              _react2.default.createElement('i', { className: 'fa fa-filter ' + styles.icon, 'aria-hidden': 'true' }),
              'L\u1ECDc',
              _react2.default.createElement('i', {
                className: (!this.state.show ? 'fa fa-chevron-down ' : 'fa fa-chevron-up ') + styles.icon,
                'aria-hidden': 'true'
              })
            ),
            _react2.default.createElement(
              _reactBootstrap.Overlay,
              {
                show: this.state.show,
                target: this.state.target,
                placement: 'bottom',
                container: this,
                containerPadding: 20
              },
              _react2.default.createElement(
                _reactBootstrap.Popover,
                { id: 'popover-filter', className: styles.popoverFilter },
                _react2.default.createElement(
                  _reactBootstrap.Tab.Container,
                  { id: 'left-tabs-example', defaultActiveKey: 'first' },
                  _react2.default.createElement(
                    'div',
                    { className: styles.contentPopover },
                    _react2.default.createElement(
                      'div',
                      { className: styles.leftTab },
                      _react2.default.createElement(
                        _reactBootstrap.Nav,
                        { bsStyle: 'pills', stacked: true, className: styles.nav },
                        _react2.default.createElement(
                          _reactBootstrap.NavItem,
                          { eventKey: 'first', className: styles.navItem },
                          'Khu v\u1EF1c'
                        ),
                        _react2.default.createElement(
                          _reactBootstrap.NavItem,
                          { eventKey: 'second', className: styles.navItem },
                          'Lo\u1EA1i h\xECnh'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.rightTab },
                      _react2.default.createElement(
                        _reactBootstrap.Tab.Content,
                        { animation: true },
                        _react2.default.createElement(
                          _reactBootstrap.Tab.Pane,
                          { eventKey: 'first' },
                          _react2.default.createElement(
                            'div',
                            { className: styles.contentAreas },
                            _react2.default.createElement(
                              'ul',
                              { className: styles.subList },
                              areas
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _reactBootstrap.Tab.Pane,
                          { eventKey: 'second' },
                          _react2.default.createElement(
                            'div',
                            { className: styles.contentCategory },
                            _react2.default.createElement(
                              'ol',
                              { className: styles.mainList },
                              types
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'button',
            { className: styles.searchButton, type: 'submit' },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'search' })
          )
        )
      );
    }
  }]);
  return Search;
}(_react.Component), _class2.propTypes = {
  addressFilter: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  categoriesFilter: _react.PropTypes.object,
  changeProvince: _react.PropTypes.func.isRequired,
  changeQuery: _react.PropTypes.func.isRequired,
  district_parent: _react.PropTypes.string,
  districts: _react.PropTypes.array,
  districts_loading: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  getSearchResult: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  initializeWithKey: _react.PropTypes.func.isRequired,
  loadDistrict: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object,
  locationUser: _react.PropTypes.object,
  position: _react.PropTypes.string,
  province: _react.PropTypes.string,
  provinces: _react.PropTypes.array,
  push: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.string,
  sort: _react.PropTypes.string,
  subCatFilter: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = Search;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.js
// module id = 722
// module chunks = 0